// TODO: ability to change inner div to another element like ul using prop

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-cluster',
  styleUrl: 'cluster.css',
  shadow: false,
})
export class Cluster {
  @Prop() justify: string = "center";
  @Prop() align: string = "center";
  @Prop() space: string = 'var(--s1)';

  render() {
    return (
      <div class="cluster" style={{'--space': this.space, '--align': this.align, '--justify': this.justify}}>
        <div>
          <slot />
        </div>
      </div>
    );
  }
}
